import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class PreferencesServices {
    getPreference() {
        return axios.get(API_URL + 'preference', { headers: authHeader() });
    }
    addPreference(data) {
        return axios.post(API_URL + 'preference', data, { headers: authHeader() });
    }
    updatePreference(id, data) {
        return axios.patch(API_URL + 'preference/' + id, data, { headers: authHeader() });
    }
    detailPreference(id) {
        return axios.get(API_URL + 'preference/' + id, { headers: authHeader() });
    }
    getByKey(type, key) {
        return axios.get(API_URL + 'preference/getkey/' + type + '/' + key, { headers: authHeader() });
    }
    showPreference(id) {
        return axios.get(API_URL + 'preference/getkey/' + id, { headers: authHeader() });
    }
    deletePreference(id) {
        return axios.delete(API_URL + 'preference/' + id, { headers: authHeader() });
    }
    generateToken(data) {
        return axios.post(API_URL + 'preference/generate-token', data, { headers: authHeader() });
    }

}

export default new PreferencesServices();
